import axiosInstance from './http';

// params:
// q: string (required)
// include_extended: boolean
// types: string "customers,facilities,contracts,works,contacts"
// <type>_page, <type>_page_size
export async function globalSearch(params = {}) {
    try {
        const response = await axiosInstance.get('search/', { params });
        return response.data; // { query, include_extended, totals, facets }
    } catch (error) {
        // Логика аналогична прочим api-модулям
        if (error?.response) {
            console.error('[globalSearchApi] GET search/ ->', error.response.status, {
                url: error.response.config?.url,
                method: error.response.config?.method,
                params: error.response.config?.params,
                data: error.response.data,
                headers: error.response.headers,
            });
        } else {
            console.error('[globalSearchApi] GET search/ -> network/error', error);
        }
        throw error;
    }
}